import axios from 'axios';
import config from '../config/environment';

// Configurar axios con interceptores
const axiosInstance = axios.create({
  baseURL: config.apiUrl,
  timeout: config.requestTimeout,
});

// Interceptor para agregar el token automáticamente
axiosInstance.interceptors.request.use(
  (config) => {
    try {
      const token = localStorage.getItem('token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch (error) {
      console.error('Error in request interceptor:', error);
    }
    return config;
  },
  (error) => {
    console.error('Request interceptor error:', error);
    return Promise.reject(error);
  }
);

// Interceptor para manejar errores de autenticación
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.error('Response interceptor error:', error);
    
    // Solo manejar errores 401 si no estamos ya en la página de login
    if (error.response?.status === 401 && window.location.pathname !== '/login') {
      console.log('401 error detected, redirecting to login');
      try {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
      } catch (e) {
        console.error('Error clearing localStorage:', e);
      }
      window.location.href = '/login';
    }
    
    // Manejar errores de red
    if (error.code === 'NETWORK_ERROR' || error.code === 'ERR_NETWORK') {
      console.error('Network error:', error);
    }
    
    return Promise.reject(error);
  }
);

export default axiosInstance;
